import React from 'react';
import { useSessionInfoQuery } from '@/api/useSessionInfoQuery';
import { useSessionStore } from '@/state/sessionStore';

export type UserRegisterProps = {
  href?: string;
  className?: string;
  registerLabel?: string;
};

/**
 * Renders a register link when the user is a guest.
 * If the user is logged in, renders nothing.
 */
const UserRegister: React.FC<UserRegisterProps> = ({
  href = '/user/register',
  className = 'theme-button block w-full px-3 py-3 text-xl font-bold tracking-wider text-center uppercase',
  registerLabel = 'Register',
}) => {
  // Trigger session info fetch to keep the store updated
  useSessionInfoQuery();
  const isGuest = useSessionStore((s) => s.isGuest);
  const effectiveIsGuest = isGuest ?? true;

  if (!effectiveIsGuest) return null;

  return (
    <a href={href} className={className}>
      {registerLabel}
    </a>
  );
};

export default UserRegister;
